import { Action } from '@ngrx/store';
import {MspAuthority, MspDeleteData, MspAuthorityForUpdate} from '../region.model';
import {Update} from '@ngrx/entity';

export enum RegionMspAuthorityActionTypes {
  GetMspAuthority = '[MspAuthority] Get Msp Member Authority',
  UpdateMspAuthority = '[MspAuthorityForUpdate] Update Msp Member Authority',
  DeleteMspAuthority = '[MspDeleteData] Delete Msp Member Authority',
  GetMspAuthoritySuccess = '[MspAuthority] Get Msp Member Authority Success',
  LoadMspAuthorityFail = '[MspAuthority] Load Msp Member Authority Fail',
}


export class GetMspAuthority implements Action {
  readonly type = RegionMspAuthorityActionTypes.GetMspAuthority;
  constructor(public payload: any = null ) {}
  
}

export class UpdateMspAuthority implements Action {
  readonly type = RegionMspAuthorityActionTypes.UpdateMspAuthority;
  constructor(public payload: MspAuthorityForUpdate[] ) {}
}

export class DeleteMspAuthority implements Action {
  readonly type = RegionMspAuthorityActionTypes.DeleteMspAuthority;
  constructor(public payload: MspDeleteData[] ) {}
}

export class GetMspAuthoritySuccess implements Action {
  readonly type = RegionMspAuthorityActionTypes.GetMspAuthoritySuccess;
  constructor(public payload: MspAuthority[]) {}
}

export class LoadMspAuthorityFail implements Action {
  readonly type = RegionMspAuthorityActionTypes.LoadMspAuthorityFail;
}

export type MspAuthorityActions = GetMspAuthority
  | UpdateMspAuthority
  | DeleteMspAuthority
  | GetMspAuthoritySuccess
  | LoadMspAuthorityFail;
